// extracted by LIB_CSS_EXTRACT_LOADER
import "./table_module.css"
export default {"container":"container-YYTMZV","table":"table-pRXxiq","header":"header-VeVQwb","body":"body-JyWjbX","footer":"footer-TNVOXP","row":"row-MACoEW","head":"head-qr4VFO","cell":"cell-OK6_dY","caption":"caption-rhvQQj"};